/* eslint-disable camelcase */
import { waitForElementToExist, toTimestamp } from '../utilities'

function hideBuyNowForNoStock () {
  if (window.theme.settings.template !== 'product.supadu') return
  const buyNowButton = document.querySelector('.shopify-payment-button')
  if (!buyNowButton) return
  const item = window.theme.productData
  if (!item) return
  if (!item.available) buyNowButton.remove()
}

function replacePreviewLabel () {
  if (window.theme.settings.template !== 'product.supadu') return
  waitForElementToExist('a[title="Read Excerpt"]').then(previewLink => {
    const previewSpan = previewLink.querySelector('span')
    if (previewSpan) {
      previewSpan.textContent = 'See Inside >'
    }
  })
}

function modifyPreorderLogic () {
  if (window.theme.settings.template !== 'product.supadu') return

  const item = window.theme.staticProductData
  if (!item) return

  const { availability, hide, sale_date } = item
  if (!sale_date || !sale_date.date) return

  // Only want to modify logic for future publication dates
  const today = toTimestamp(new Date())
  const publicationDate = new Date(item.sale_date.date.replace(/ /g, 'T'))
  const publicationDateTimestamp = toTimestamp(publicationDate)
  if (publicationDateTimestamp < today) return

  let showNypMessage = false
  const addToCart = document.querySelector('.add-to-cart')

  // Display NYP message if no "Add to Cart" button exists
  // No buy button means no stock in Shopify
  if (!addToCart) {
    showNypMessage = true
  } else {
    const cartText = addToCart.querySelector('span')
    // Change pre-order text to 'Add to cart'
    if (cartText && availability === 20 && !hide) {
      cartText.textContent = 'Add to cart'
    } else {
      addToCart.remove()
      showNypMessage = true
    }
  }

  if (!showNypMessage) return

  // Get or create "Not Yet Published" message element
  const nypMessage = window.theme.settings.bookDetailsSettings.not_yet_published_message
  const oosElement = document.querySelector('.out_of_stock_message')
  if (oosElement) {
    oosElement.textContent = nypMessage
    return
  }

  const productForm = document.querySelector('.js-product-single__form')
  productForm.innerHTML = `
    <p class='out_of_stock_message'>
      ${nypMessage}
    </p>
  `
}

function customFunctions () {
  hideBuyNowForNoStock()
  replacePreviewLabel()
  modifyPreorderLogic()
}

module.exports = { customFunctions }
